import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "company-type" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($options.company_type.icon)
      ? (_openBlock(), _createBlock(_component_Icon, {
          key: 0,
          icon: $options.company_type.icon,
          width: "1.4rem",
          height: "1.4rem",
          stroke: "var(--gray-light-600)",
          "stroke-width": "1"
        }, null, 8 /* PROPS */, ["icon"]))
      : _createCommentVNode("v-if", true),
    _createTextVNode(" " + _toDisplayString($options.company_type.title), 1 /* TEXT */)
  ]))
}